import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import api from "../api/client";

const MarketingControls = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [heroTitle, setHeroTitle] = useState("");
  const [heroSubtitle, setHeroSubtitle] = useState("");
  const [topProductIds, setTopProductIds] = useState("");
  const [topProducts, setTopProducts] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/homepage");
      const payload = res.data?.data || {};
      setHeroTitle(payload.config?.heroTitle || "");
      setHeroSubtitle(payload.config?.heroSubtitle || "");
      setTopProductIds((payload.config?.topProductIds || []).join(","));
      setTopProducts(payload.topProducts || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/homepage", {
        heroTitle,
        heroSubtitle,
        topProductIds: topProductIds.split(",").map((x) => x.trim()).filter(Boolean),
      });
      await load();
      alert("Marketing settings saved");
    } catch (e) {
      alert(e.response?.data?.error || "Failed to save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="container" style={{ padding: 24 }}>
          <h1>Marketing Controls</h1>
          {loading ? <p>Loading...</p> : (
            <>
              <form onSubmit={save} style={{ maxWidth: 760, display: "grid", gap: 12 }}>
                <label>Hero Title</label>
                <input value={heroTitle} onChange={(e) => setHeroTitle(e.target.value)} className="form-input" />
                <label>Hero Subtitle</label>
                <textarea value={heroSubtitle} onChange={(e) => setHeroSubtitle(e.target.value)} className="form-textarea" rows={3} />
                <label>Top Product IDs (comma-separated)</label>
                <input value={topProductIds} onChange={(e) => setTopProductIds(e.target.value)} className="form-input" />
                <button disabled={saving} className="btn btn-primary" type="submit">{saving ? "Saving..." : "Save"}</button>
              </form>
              <div style={{ marginTop: 24 }}>
                <h3>Current Top Products</h3>
                <ul>
                  {topProducts.map((p) => <li key={p.id}>{p.name} ({p.id})</li>)}
                </ul>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarketingControls;
